<template>
    <div>
        <Table :columns="columns" :data="resources" size="small" stripe>
        </Table>
    </div>
</template>
<script>
export default {
    props: {
        row: Object
    },
    computed: {
        resources() {
            return this.row.details;
        },
        columns() {
            return [
                {
                    title: this.$t("smgActivityLog.createdDate"),
                    key: "created_date",
                    minWidth: 180,
                },
                {
                    title: this.$t("smgActivityLog.createdBy"),
                    key: "created_by_name",
                    minWidth: 150,
                },
                {
                    title: this.$t("smgActivityLog.action"),
                    key: "action",
                    minWidth: 120,
                },
                {
                    title: this.$t("smgActivityLog.columnName"),
                    key: "column_name",
                    minWidth: 150,
                },
                {
                    title: this.$t("smgActivityLog.oldValue"),
                    key: "old_value",
                    minWidth: 250,
                },
                {
                    title: this.$t("smgActivityLog.newValue"),
                    key: "new_value",
                    minWidth: 250,
                },
                {
                    title: this.$t("smgActivityLog.refObjectId"),
                    key: "ref_object_id",
                    minWidth: 280,
                    align: "center",
                },
            ];
        }
    },
    methods: {}
};
</script>
